export const GET_CAREERS = "careers/GET_CAREERS";
export const GET_CAREERS_SUCCESS = "careers/GET_CAREERS_SUCCESS";
export const GET_CAREERS_FAILURE = "careers/GET_CAREERS_FAILURE";
